import IStepProps from './IStepProps'
import React from 'react'

const Step = ({children, changeStep}: IStepProps) => {
    return React.cloneElement(children, {changeStep: changeStep})
}

export default Step